// import { FC, useEffect, useState, useRef } from 'react';
// import usePlacesAutocomplete, { getDetails, getZipCode } from 'use-places-autocomplete';
// import Select, { InputActionMeta, SingleValue } from 'react-select';

// import Select, { InputActionMeta, SingleValue } from 'react-select';
// import usePlacesAutocomplete, { Suggestion } from 'use-places-autocomplete';
// import CreatableSelect from 'react-select/creatable';
import Autocomplete from 'react-google-autocomplete';

import { FC, useEffect, useState, useRef } from 'react';
import usePlacesAutocomplete, { getDetails, getZipCode, HookArgs, HookReturn } from 'use-places-autocomplete';

import Select, { SingleValue } from 'react-select';
import { setIn } from 'formik';
import { useDebounce } from '../../../../_metronic/helpers';
import { WIZ_THEME } from './WizSelect';
import { get } from 'core-js/core/dict';
import { safariVersion } from '../../../helpers/funcs';

interface Props {
  value: string | undefined;
  onChange: (newValue: string) => void;
  onChangePostalCode?: (newValue: string) => void;
  onChangeDetailedAddress?: (newValue: string) => void;
  className?: string;
  disabled?: boolean;
  classNamePrefix?: string;
  placeholder?: string;
}

interface PlaceResult {
  address_components?: google.maps.GeocoderAddressComponent[];
  formatted_address?: string;
  html_attributions?: string[];
  name?: string;
  place_id?: string;
  types?: string[];
}

// const GoogleAddressAutocomplete: React.FC<Props> = (props) => {
//   // we need a short delay to allow google maps api to load - otherwise we get an nasty error :-(  -- temporary workaround
//   const [showComponent, setShowComponent] = useState(false);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowComponent(true);
//     }, 1000);

//     return () => {
//       clearTimeout(timer);
//     };
//   }, []);

//   if (!showComponent) {
//     return null; // Render nothing while waiting for the delay
//   }

//   return props.disabled !== true ? (
//     <Autocomplete
//       apiKey={'AIzaSyBZBHYb2tdpFGutx3PRHus-ONIgSIORr0Y'}
//       onPlaceSelected={(place: PlaceResult) => {
//         props.onChange(place?.formatted_address || '');
//         if (place?.address_components) {
//           const zipcode_element = place.address_components.find((p) => p.types.includes('postal_code'));
//           zipcode_element && props.onChangePostalCode && props.onChangePostalCode(zipcode_element.long_name);
//         }
//       }}
//       options={{
//         types: ['address'],
//       }}
//       className={props.className || 'form-control form-control-solid mb-3 mb-lg-0 address'}
//       defaultValue={props.value}
//       onBlur={(e) => {
//         props.onChange(e.target.value);
//       }}
//     />
//   ) : (
//     <input className="form-control form-control-solid mb-3 mb-lg-0" value={props.value} disabled />
//   );
// };

const AddressAutocomplete: FC<Props> = ({
  value,
  onChange,
  className,
  classNamePrefix,
  placeholder,
  onChangePostalCode,
  onChangeDetailedAddress,
  disabled,
}) => {
  try {
    if (safariVersion && safariVersion < 15.4) {
      throw Error(`Autocomplete is not supported on Safari ${safariVersion}`);
    }

    const {
      ready,
      value: pvalue,
      suggestions: { status, data },
      setValue,
      clearSuggestions,
    } = usePlacesAutocomplete({
      requestOptions: {
        /* Define search scope here */
      },
      debounce: 300,
    });

    const handleInput = (e: any) => setValue(e.target.value);
    const handleSelect = (suggestion: any) => {
      setValue(suggestion.description, false);
      clearSuggestions();
    };

    const [options, setOptions] = useState<any[] | undefined>([]);
    const [inputValue, setInputValue] = useState<string | undefined>('');
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
      if (inputValue && inputValue.length > 3) {
        setValue(inputValue);
        setMenuOpen(true);
      } else {
        setMenuOpen(false);
      }
    }, [inputValue]);

    useEffect(() => {
      if (ready) {
        setOptions(
          data.map((suggestion: any) => {
            return { value: suggestion.place_id, label: suggestion.description };
          })
        );
      }
    }, [data, ready]);

    let skipOnBlur = false; // ensure we don't call onBlur on same event as onChange

    return (
      <Select
        theme={WIZ_THEME}
        options={options}
        value={value ? { value: value, label: value } : null}
        onInputChange={setInputValue}
        onChange={(selection) => {
          if (selection === null || !selection.label) {
            onChange('');
            setInputValue('');
          } else {
            if (selection.value && (onChangePostalCode || onChangeDetailedAddress)) {
              // placed in a block due to missing polyfills in google maps api :-(
              getDetails({ placeId: selection.value }).then((details) => {
                let placeDetails = details as google.maps.places.PlaceResult;
                if (placeDetails && placeDetails.address_components) {
                  let postalCodeDetail = placeDetails.address_components.filter((det) =>
                    det.types.includes('postal_code')
                  );
                  if (postalCodeDetail.length > 0)
                    onChangePostalCode && onChangePostalCode(postalCodeDetail[0].long_name);
                  if (onChangeDetailedAddress)
                    onChangeDetailedAddress && onChangeDetailedAddress(placeDetails.formatted_address || '');
                }
              });
            }
            onChange(selection.label);
            setInputValue(undefined);
            skipOnBlur = true;
          }
        }}
        className={className}
        classNamePrefix={classNamePrefix}
        placeholder={disabled ? value : placeholder || 'Enter address...'}
        menuIsOpen={menuOpen}
        isLoading={!ready}
        menuPlacement={'top'}
        isClearable={true}
        inputValue={inputValue}
        noOptionsMessage={() => null}
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        isDisabled={disabled}
        onBlur={(val) => {
          if (!skipOnBlur) onChange(inputValue || value || '');
        }}
        onFocus={(val) => {
          if (value) setInputValue(value);
        }}
      />
    );
  } catch (error) {
    // revert to regular input on exception due to old browsers with google maps api use of BigInt and HtmlDialogElement
    useEffect(() => {
      console.info('autocomplete is not available');
    }, []);
    return (
      <input
        className="form-control form-control-solid mb-3 mb-lg-0"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    );
  }
};

// old code - not in use...
function useSafePlacesAutocomplete(options: HookArgs): HookReturn {
  try {
    // Attempt to use the original hook
    return usePlacesAutocomplete(options);
  } catch (error) {
    if (error instanceof ReferenceError) {
      console.warn('usePlacesAutocomplete is not available:', error.message);
      //     // Return default values to prevent crashes
      return {
        ready: true,
        value: '',
        suggestions: {
          status: '',
          data: [
            {
              place_id: 'test',
              description: 'test',
              matched_substrings: [],
              structured_formatting: {
                main_text: '',
                main_text_matched_substrings: [{ length: 0, offset: 0 }],
                secondary_text: '',
              },
              terms: [],
              types: [],
            },
          ],
          loading: false,
        },
        setValue: (val) => {},
        clearSuggestions: () => {},
        clearCache: () => {},
        init: () => {},
      };
    } else {
      // Re-throw other errors
      throw error;
    }
  }
}
// end of old code not in use...

export { AddressAutocomplete };
